<template>
<div class="chapter">
<div class="inner_page">
<p class="epi">We two being one, are it.</p>
<p class="epi-att"><span class="smallcaps">JOHN DONNE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?30ec4a08